export default __webpack_public_path__ + "static/layout-example-sideNav-light-207d8cbc275d822146c64b0c057f4a56.png";